const STYLES = {
  routing: 'bg-violet-500/15 text-violet-400',
  cache: 'bg-emerald-500/15 text-emerald-400',
  evals: 'bg-amber-500/15 text-amber-400',
};

export default function FeatureTag({ feature, label }) {
  return (
    <span className={`px-2 py-0.5 rounded-md text-[10px] font-semibold uppercase tracking-wider ${STYLES[feature]}`}>
      {label}
    </span>
  );
}
